import {
  TagIcon,
  ChatBubbleLeftRightIcon,
  UserGroupIcon,
  QuestionMarkCircleIcon,
  SpeakerWaveIcon,
  CalendarIcon,
  AcademicCapIcon,
  ClockIcon,
  PresentationChartLineIcon,
  BriefcaseIcon,
  HeartIcon,
  LightBulbIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  DocumentTextIcon,
  CogIcon,
  StarIcon,
  TrophyIcon,
  RocketLaunchIcon,
  ShieldCheckIcon,
  FireIcon,
  BoltIcon,
  GlobeAltIcon,
  BuildingOfficeIcon,
  PhoneIcon,
  EnvelopeIcon,
  HomeIcon,
  MapPinIcon,
  CameraIcon,
  MusicalNoteIcon,
  FilmIcon,
  BookOpenIcon,
  BeakerIcon,
  WrenchScrewdriverIcon,
  PaintBrushIcon,
  CurrencyDollarIcon,
  ChartBarIcon,
  NewspaperIcon,
  MegaphoneIcon
} from '@heroicons/react/24/outline';

// Map database icon names to Heroicon components
export const iconMapping = {
  // Post category icons
  'chat': ChatBubbleLeftRightIcon,
  'users': UserGroupIcon,
  'question-circle': QuestionMarkCircleIcon,
  'megaphone': MegaphoneIcon,
  'lightbulb': LightBulbIcon,
  'tag': TagIcon,
  'document': DocumentTextIcon,
  'information': InformationCircleIcon,
  'exclamation': ExclamationTriangleIcon,
  'heart': HeartIcon,
  'star': StarIcon,
  'trophy': TrophyIcon,
  'rocket': RocketLaunchIcon,
  'shield': ShieldCheckIcon,
  'fire': FireIcon,
  'bolt': BoltIcon,
  'globe': GlobeAltIcon,
  'building': BuildingOfficeIcon,
  'briefcase': BriefcaseIcon,
  'home': HomeIcon,
  'map-pin': MapPinIcon,
  'camera': CameraIcon,
  'music': MusicalNoteIcon,
  'film': FilmIcon,
  'book': BookOpenIcon,
  'beaker': BeakerIcon,
  'wrench': WrenchScrewdriverIcon,
  'paint': PaintBrushIcon,
  'dollar': CurrencyDollarIcon,
  'chart': ChartBarIcon,
  'newspaper': NewspaperIcon,
  
  // Event type icons
  'calendar': CalendarIcon,
  'graduation-cap': AcademicCapIcon,
  'clock': ClockIcon,
  'presentation': PresentationChartLineIcon,
  'cog': CogIcon,
  'phone': PhoneIcon,
  'envelope': EnvelopeIcon,
  'speaker': SpeakerWaveIcon,
  
  // Default fallbacks
  'default-category': TagIcon,
  'default-event': CalendarIcon
};

// Get icon component by name
export const getIconComponent = (iconName, type = 'category') => {
  if (!iconName) {
    return type === 'event' ? iconMapping['default-event'] : iconMapping['default-category'];
  }
  
  return iconMapping[iconName] || (type === 'event' ? iconMapping['default-event'] : iconMapping['default-category']);
};

export default { iconMapping, getIconComponent }; 